
















import Vue from "vue";
import { DeliveryModeAttributeMeta } from "../models/DeliveryModeAttributeMeta";
export default Vue.extend({
  props: {
    value: {
      type: Array as () => DeliveryModeAttributeMeta[]
    }
  }
});
